/* PMP — count-up for percentage stats (results block). Respects reduced motion. */
(function(){
  function run(el){
    var raw = (el.getAttribute('data-countup-to') || el.textContent || '').replace(/[^0-9.]/g,'');
    var target = parseFloat(raw);
    if (!isFinite(target)) return;
    var suffix = /%/.test(el.getAttribute('data-countup-suffix') || el.textContent) ? '%' : '';
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.textContent = target + suffix; return;
    }
    var dur = 1500, start = null;
    el.textContent = '0' + suffix;
    function step(ts){
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = target + suffix;
    }
    requestAnimationFrame(step);
  }
  function init(){
    var els = document.querySelectorAll('[data-countup]');
    if (!els.length) return;
    els.forEach(function(el){
      var t = (el.textContent || '').trim();
      if (!el.getAttribute('data-countup-to')) el.setAttribute('data-countup-to', t);
      el.setAttribute('data-countup-suffix', t);
      el.style.fontVariantNumeric = 'tabular-nums';
      el.style.minWidth = '2.6ch';
      el.style.display = 'inline-block';
    });
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.45 });
    els.forEach(function(el){ io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
